import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search-enter",
  "use": "icon-search-enter-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-search-enter\"><defs><style type=\"text/css\"></style></defs><path d=\"M916.210526 242.526316v215.578947H204.8l194.021053-194.021052-75.452632-75.452632-323.368421 323.368421 323.368421 323.368421 75.452632-75.452632-194.021053-194.021052h819.2v-323.368421z\" p-id=\"3180\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol